<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.stock-management") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row>
        <v-col cols="12">
          <v-radio-group
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque
            "
            class="mt-0"
            hide-details
          >
            <v-row>
              <v-col cols="12" class="mt-2">
                <BaseTextField
                  persistent-hint
                  :label="$t('events.stock')"
                  min="0"
                  type="number"
                  :placeholder="$t('events.event-config.insert-product-stock')"
                  v-model.number="
                    $produtos_gerenciar.cadastro.dados_cadastrais.estoque
                  "
                  :hint="'ℹ️ ' + $t('events.event-config.stock-info')"
                  :required="manageStock"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-radio
                  :label="$t('events.event-config.manage-stock')"
                  :value="1"
                  class="rounded-lg pa-2"
                  style="border: 1px solid rgb(0 0 0 / 42%)"
                  active-class="active-class"
                  color="tertiary"
                ></v-radio>
                <v-radio
                  :label="$t('events.event-config.sell-without-stock')"
                  :value="0"
                  class="rounded-lg pa-2"
                  style="border: 1px solid rgb(0 0 0 / 42%)"
                  active-class="active-class"
                  color="tertiary"
                ></v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
export default {
  name: "InventoryManage",
  components: {
    BaseTextField,
  },
  data: () => ({}),
  computed: {
    manageStock() {
      return (
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos
          .length === 0 &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque ===
          1
      );
    },
  },
};
</script>
<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>

<!-- !== IFRAME && LINK -->
